import { createElement } from 'react';
import styled from 'styled-components';

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  max-width: ", ";\n\n  ", "\n\n  @media (max-width: 960px) {\n    max-width: ", ";\n    margin-bottom: ", ";\n  }\n\n  @media (max-width: 680px) {\n    max-width: ", ";\n\n    &:last-child {\n      margin-bottom: unset;\n    }\n  }\n\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Item = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject(), function (_ref) {
  var col = _ref.col,
      _ref$gap = _ref.gap,
      gap = _ref$gap === void 0 ? 1 : _ref$gap;
  return col && col < 12 ? 100 * col / 12 - gap + "%" : '100%';
}, function (_ref2) {
  var marginBottom = _ref2.marginBottom;
  return marginBottom && "\n\t\tmargin-bottom: " + marginBottom + "px;\n\t";
}, function (_ref3) {
  var colTablet = _ref3.colTablet,
      _ref3$gapTablet = _ref3.gapTablet,
      gapTablet = _ref3$gapTablet === void 0 ? 1 : _ref3$gapTablet;
  return colTablet && colTablet < 12 ? 100 * colTablet / 12 - gapTablet + "%" : '100%';
}, function (_ref4) {
  var _ref4$marginBottom = _ref4.marginBottom,
      marginBottom = _ref4$marginBottom === void 0 ? 10 : _ref4$marginBottom;
  return marginBottom + "px";
}, function (_ref5) {
  var colMobile = _ref5.colMobile,
      _ref5$gapMobile = _ref5.gapMobile,
      gapMobile = _ref5$gapMobile === void 0 ? 1 : _ref5$gapMobile;
  return colMobile && colMobile < 12 ? 100 * colMobile / 12 - gapMobile + "%" : '100%';
}, function (_ref6) {
  var stretch = _ref6.stretch;
  return stretch && "\n    display: flex;\n    align-self: stretch;\n  ";
});

function _templateObject$1() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: ", ";\n  flex-wrap: wrap;\n  align-items: ", ";\n\n  &:after {\n    content: '';\n    max-width: ", ";\n    width: 100%;\n\n    @media (max-width: 960px) {\n      max-width: ", ";\n    }\n\n    @media (max-width: 680px) {\n      max-width: ", ";\n    }\n  }\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}

var StyledFlex = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$1(), function (_ref) {
  var justifyContent = _ref.justifyContent;
  return justifyContent || 'space-between';
}, function (_ref2) {
  var align = _ref2.align;
  return align || 'center';
}, function (_ref3) {
  var col = _ref3.col,
      _ref3$gap = _ref3.gap,
      gap = _ref3$gap === void 0 ? 1 : _ref3$gap;
  return col && col < 12 ? 100 * col / 12 - gap + "%" : '100%';
}, function (_ref4) {
  var colTablet = _ref4.colTablet,
      _ref4$gapTablet = _ref4.gapTablet,
      gapTablet = _ref4$gapTablet === void 0 ? 1 : _ref4$gapTablet;
  return colTablet && colTablet < 12 ? 100 * colTablet / 12 - gapTablet + "%" : '100%';
}, function (_ref5) {
  var colMobile = _ref5.colMobile,
      _ref5$gapMobile = _ref5.gapMobile,
      gapMobile = _ref5$gapMobile === void 0 ? 1 : _ref5$gapMobile;
  return colMobile && colMobile < 12 ? 100 * colMobile / 12 - gapMobile + "%" : '100%';
});

var Flex = function Flex(_ref6) {
  var children = _ref6.children,
      col = _ref6.col,
      colTablet = _ref6.colTablet,
      colMobile = _ref6.colMobile,
      gap = _ref6.gap,
      gapTablet = _ref6.gapTablet,
      gapMobile = _ref6.gapMobile,
      align = _ref6.align,
      justifyContent = _ref6.justifyContent,
      className = _ref6.className,
      style = _ref6.style;
  return createElement(StyledFlex, {
    col: col,
    colTablet: colTablet,
    colMobile: colMobile,
    gap: gap,
    gapTablet: gapTablet,
    gapMobile: gapMobile,
    align: align,
    justifyContent: justifyContent,
    className: className,
    style: style
  }, children, createElement(Item, {
    col: col,
    colTablet: colTablet,
    colMobile: colMobile,
    gap: gap,
    gapTablet: gapTablet,
    gapMobile: gapMobile
  }));
};

export { Flex, Item };